import { useState } from 'react'
import { BsBank2, BsFillWalletFill } from 'react-icons/bs'
import { FaRegMoneyBillAlt } from 'react-icons/fa'
import { GiMoneyStack } from 'react-icons/gi'
import { HiDotsVertical } from 'react-icons/hi'
import { IoEyeOutline, IoPersonAddOutline } from 'react-icons/io5'
import { FiEdit, FiTrash2 } from 'react-icons/fi'
import { useDispatch } from 'react-redux'
import { IBank, IUser } from 'safe'
import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import { DataTabView } from '../../components/Display/ViewWithTabs'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import Restaurant from '../../assets/images/restaurant.svg'
import { ISuscription } from './Suscriptions'
import { formatPipe } from '../../utils/utils'

const SuscriptionCard: React.FC<SuscriptionCardProps> = ({
  suscription,
  onPressCardProp = () => null,
  onView,
  onEdit,
  onDelete,
  onAddProduct,
  onAddSubscriber,
  userRole,
}) => {
  const [modalDescription, setModalDescription] = useState<boolean>(false)
  const [visibleMenu, setVisibleMenu] = useState<boolean>(false)
  const [displayConfirm, setDisplayConfirm] = useState<boolean>(false)
  const [editModal, setEditModal] = useState<boolean>(false)
  const [dataWithTabs, setDataWithTabs] = useState<DataTabView[]>([])

  const { addAlert } = useSnackBars()

  const objTransform = {
    monthly: (duration: number) => `${duration} Mes${duration > 1 ? 'es' : ''}`,
    weekly: (duration: number) => `${duration} Semana${duration > 1 ? 's' : ''}`,
    biweekly: (duration: number) => `${duration} Quincena${duration > 1 ? 's' : ''}`,
    quarterly: (duration: number) => `${duration} Trimestre${duration > 1 ? 's' : ''}`,
    annual: (duration: number) => `${duration} Año${duration > 1 ? 's' : ''}`,
  }

  const frequencyTranslation = {
    monthly: 'Mensual',
    weekly: 'Semanal',
    biweekly: 'Quincenal',
    quarterly: 'Trimestral',
    annual: 'Anual',
  }

  const ivaTypeTransform = {
    GENERAL: 'General',
    REDUCED: 'Reducido',
    EXEMPT: 'Exento',
    SUMPTUARY: 'Suntuario',
  }

  const onPressCard = () => {}

  const dispatch = useDispatch()

  const toggle = (): void => {
    setVisibleMenu((state) => !state)
  }

  const setVisible = async (wantedState: boolean) => {
    try {
      addAlert({
        message: 'Actualizando cuenta...',
        status: 'loading',
      })
      //   await dispatch(setAccountVisible(String(table.id), wantedState))
      addAlert({
        message: 'Visibilidad actualizada con éxito',
        status: 'success',
      })
    } catch (error: any) {
      addAlert({
        message:
          error.response.data.message ||
          'Error al modificar disponibilidad en cuenta',
        status: 'error',
      })
    } finally {
      toggle()
    }
  }

 

  return (
    <>
     
      <div className="2xl:w-96 w-80 shadow-lg rounded-lg p-4 mb-5 mr-5 text-xl flex justify-between relative dark:bg-black m-auto">
        <div
          className="w-80 cursor-pointer"
          onClick={() => onPressCardProp()}
        >
          <div className="h-8 flex items-center">
            <div className="flex items-center truncate text-primary-600 font-medium">
             
              <div className="truncate text-sm max-h-10 dark:text-white">
                {suscription?.description}
              </div>
            </div>
          </div>

          <div className="flex flex-row">
            <div className="text-sm max-h-10 dark:text-white mr-2">
              Frecuencia:
            </div>
            <div className="text-sm max-h-10 dark:text-white">
              {frequencyTranslation[suscription?.frequency]}
            </div>
          </div>

          <div className="flex flex-row">
            <div className="text-sm max-h-10 dark:text-white mr-2">
              Tipo de IVA:
            </div>
            <div className="text-sm max-h-10 dark:text-white">
              {ivaTypeTransform[suscription?.ivaType]}
            </div>
          </div>

          <div className="flex flex-row">
            <div className="text-sm max-h-10 dark:text-white mr-2">
              Estado:
            </div>
            <div className="text-sm max-h-10 dark:text-white">
              {suscription?.active ? 'Habilitado' : 'Inhabilitado'}
            </div>
          </div>

          <div className="flex flex-row">
            <div className="text-sm max-h-10 dark:text-white mr-2">
              Precio:
            </div>
            <div className="text-sm max-h-10 dark:text-white">
              {`$ ${formatPipe(suscription?.total)}`}
            </div>
          </div>
        </div>

          <FloatingMenu
            onClose={() => {
              setVisibleMenu(false)
            }}
            visible={visibleMenu}
            options={{
              onCustomButtons: [
                {
                  title: 'Ver',
                  action: () => {
                    onView && onView(suscription)
                  },
                  display: true,
                  icon: <IoEyeOutline size={18} className="text-primary" />,
                  color: 'text-primary',
                },
                {
                  title: 'Editar',
                  action: () => {
                    onEdit && onEdit(suscription)
                  },
                  display: userRole !== 'cashier',
                  icon: <FiEdit size={18} className="text-primary" />,
                  color: 'text-primary',
                },
                {
                  title: 'Añadir suscriptor',
                  action: () => {
                    onAddSubscriber && onAddSubscriber(suscription)
                  },
                  display: true,
                  icon: <IoPersonAddOutline size={18} className="text-green-600" />,
                  color: 'text-green-600',
                },
                {
                  title: 'Eliminar',
                  action: () => setDisplayConfirm(true),
                  display: userRole !== 'cashier',
                  icon: <FiTrash2 size={18} className="text-red-600" />,
                  color: 'text-red-600',
                },
              ],
            }}
          >
            <HiDotsVertical
              className="cursor-pointer text-gray-400"
              onClick={toggle}
            />
          </FloatingMenu>
      </div>

      <ModalConfirm
        title={'¿Está seguro que desea eliminar esta suscripción?'}
        displayConfirmModal={displayConfirm}
        onConfirm={() => {
            onDelete && onDelete(suscription)
        }}
        onCancel={() => setDisplayConfirm(false)}
      ></ModalConfirm>
    </>
  )
}

interface SuscriptionCardProps {
  suscription: ISuscription
  fromSafeBox?: boolean
  onPressCardProp?: Function
  onView?: Function
  onEdit?: Function
  banks?: IBank[]
  onDelete?: Function
  onWatch?: Function
  onAddProduct?: Function
  onAddSubscriber?: Function
  userRole?: string
}

export default SuscriptionCard